((app, ng) => {
    app.controller("infoCardCtrl", _basePolicyInfoCtrl);

    _basePolicyInfoCtrl.$inject = ["$state", "$mdDialog"];
    function _basePolicyInfoCtrl($state, $mdDialog) {
        var $ctrl = this;
        $ctrl.isArray = ng.isArray;


        // items might contain additional information that's not enough to 
        // warrant usage of the More Detail state.  We will use a modal instead
        $ctrl.additionalDetail = function (title, data, $event) {
            $mdDialog.show({
                locals: { payload: { title: title, data: data } },
                controller: "additionalDetailCtrl",
                templateUrl: "/App/States/Modals/AdditionalDetail/additional.detail.html",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                fullscreen: false
            });
        };

        //
        // When the component initializes, if the data is not an array,
        // convert it to one. This is so we can cut down on type checking
        // (array or not array) in the template and remove duplicated code.
        //
        $ctrl.$onInit = function () {
            $ctrl.data = _convertToArray($ctrl.data);
            if (!$ctrl.data && !$ctrl.initQuery) {
                $ctrl.isExpanded = false;
                $ctrl.isDisabled = true;
            }
            else if ($ctrl.data && !$ctrl.initQuery) {
                if (!$ctrl.data.length) {
                    $ctrl.isExpanded = false;
                    $ctrl.isDisabled = true;
                }
            }

            // eventually this will go back to being $ctrl.loadInitial()
            // so we can query data on click vs loading here
            // but right now we just want all of the data to show
            if ($ctrl.initQuery) {
                loadInitial();
            }
        };

        //
        // ******** CURRENTLY RAN ON LOAD ********
        // Some info cards do not come with data from the policy.
        // So the initQuery binding is used and called when the
        // user clicks "Load More" 
        //
        function loadInitial() {
            $ctrl.queried = true;
            $ctrl.initQuery()
                .then((response) => {
                    $ctrl.data = response;
                    if (!$ctrl.data.length) {
                        $ctrl.isExpanded = false;
                        $ctrl.isDisabled = true;
                    }
                });
        }

        $ctrl.calculateWidth = () => {
            let width = 100 / $ctrl.selectors.length;
            return { "width": width + "%" };
        };

        //
        // Some info cards come with a glance view amount of data.
        // If there is more data that can be loaded by a query then
        // that query is in the query binding and called when a glance
        // item is expanded.
        //
        $ctrl.executeSubQuery = (item) => {
            if ($ctrl.query) {
                if (item.isExpanded) {
                    item.isExpanded = false;
                } else {
                    var alreadyExpanded = $ctrl.data.filter(d => d.isExpanded === true)[0];
                    if (alreadyExpanded) {
                        alreadyExpanded.isExpanded = false;
                    }
                    item.isExpanded = true;
                    $ctrl.query(item)
                        .then((response) => {
                            ng.extend(item, response);
                        });
                }
            }
        };

        //
        // Get more details
        //
        $ctrl.getMoreDetails = function (queryCallback, item, policyId, cardTitle) {
            $state.go("Root.Policies.MoreDetail", { query: queryCallback, item: item, MappedPolicyId: policyId, cardTitle: cardTitle });
        };

        //
        // Facade function that delegates the parsing of complex
        // data for the ui.
        // @param {Array | Object} data 
        // @param {Object} selector 
        //
        $ctrl.process = function (data, properties) {
            return _access(data, properties);
        };

        //
        // Iterates over each property that needs to be accessed and then 
        // calls _recurse() on those properties and adds the returned
        // values onto a new object under that property name. If the value
        // is an array, join it into a comma separated list. If the returning
        // object is empty return an empty string instead.
        // @param {Object} data 
        // @param {String | Array} properties 
        //
        function _access(data, properties) {
            properties = _convertToArray(properties);
            var results = {};
            properties.forEach(function (property) {
                var result = _recurse(data, property);
                if (result || result === 0) {
                    results[property] = result;
                }
            });
            return Object.keys(results).length ? results : "";
        }

        //
        // Looks for a property on a given object. If that property does not exist
        // on the current level it recurses down into nested object/arrays to
        // search there.
        // @param {Object} data 
        // @param {String} property 
        // @returns Property value or undefined.
        //
        function _recurse(data, property) {
            var keys = Object.keys(data);
            var value;
            keys.some(function (key) {
                if (key === property) {
                    value = data[key];
                    return true;
                }
                if (data[key] && typeof data[key] === "object") {
                    value = _recurse(data[key], property);
                    return value !== undefined;
                }
            });
            return value;
        }

        //
        // Takes any passed parameter and returns an arrayitized
        // version.
        // @param {any} item 
        // 
        function _convertToArray(item) {
            if (!$ctrl.isArray(item) && item) {
                item = [item];
            }
            return item;
        }
    }
})(window.app, window.angular);